import script from "./EditarCitaModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditarCitaModal.vue?vue&type=script&setup=true&lang=js"

import "./EditarCitaModal.vue?vue&type=style&index=0&id=212730b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-212730b8"]])

export default __exports__